import ErrorBgEn from 'assets/images/errorFallbackEn.svg';
import ErrorBgFr from 'assets/images/errorFallbackFr.svg';

import { useTranslation } from 'react-i18next';

import { Box, Typography, Button } from '@mui/material';

import { stylesError, stylesErrorTitle } from '@/utils/globalStyles';

export function ErrorServiceFallback() {
  const { t, i18n } = useTranslation('components');
  return (
    <Box
      sx={{ backgroundImage: `url(${i18n.language === 'fr' ? ErrorBgFr : ErrorBgEn})`, ...stylesError }}
      role='alert'
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', mt: '100px' }}>
        <Box component='h1' sx={stylesErrorTitle}>
          {t('errorServiceFallback.title')}
        </Box>
        <Typography variant='h1' component='p'>
          {t('errorServiceFallback.subtitle')}
        </Typography>
      </Box>
      <br />
      <br />
      <Button variant='contained' href='/'>
        {t('errorServiceFallback.back')}
      </Button>
    </Box>
  );
}
